import React from 'react';
import styles from './changeStatusConfirmationPopup.module.css'; 
import { tWithKeyAttr as t } from '../../../i18nHelper';

interface ChangeStatusConfirmationPopupProps {
  onClose: () => void;
  onConfirmSingle: () => void;
  onConfirmAll: () => void;
}

const ChangeStatusConfirmationPopup: React.FC<ChangeStatusConfirmationPopupProps> = ({
  onClose,
  onConfirmSingle,
  onConfirmAll,
}) => {
  return (
    <div className={styles.popupContainer}>
      <h4 className={styles.title}>{t('CHANGE_STATUS_POPUP_TITLE')}</h4>
      <p className={styles.subtitle}>{t('CHANGE_STATUS_POPUP_SUBTITLE')}</p>
      <div className={styles.buttonsWrapper}>
        <button className={`button button_white ${styles.btn}`} onClick={onConfirmSingle}>
          {t('CHANGE_STATUS_POPUP_BUTTON_SINGLE')}
        </button>
        <button className={`button ${styles.btn}`} onClick={onConfirmAll}>
          {t('CHANGE_STATUS_POPUP_BUTTON_ALL')}
        </button>
      </div>
       <button className={styles.closeButton} onClick={onClose}>
         {t('CLOSE_BUTTON_TEXT')}
       </button>
    </div>
  );
};

export default ChangeStatusConfirmationPopup;

